import { createSelector } from "@reduxjs/toolkit";
import { palletLayoutKind, parsePalletLayout, } from "store/scene/pallet-layout";
export var selectUserRoot = function (state) { return state.user; };
export var selectUserSystems = function (state) {
    return selectUserRoot(state).systems;
};
export var selectUserActiveSystem = function (state) {
    return selectUserRoot(state).activeSystem;
};
export var selectUserErrors = function (state) {
    return selectUserRoot(state).error;
};
export var selectIsUserDataLoading = function (state) {
    return selectUserRoot(state).isLoading;
};
export var selectActiveFolderId = function (state) {
    return selectUserRoot(state).activeFolderId;
};
export var selectUserId = function (state) { return selectUserRoot(state).userId; };
export var selectLibraryItems = function (state) {
    return selectUserRoot(state).libraryItems;
};
/*
 * The user's saved pallet layouts, by name. Kept in a fixed order rather than
 * by when they were saved: overwriting one would otherwise move it, and where
 * an entry sits in the list is part of how it is found again. Same names keep
 * the order they were saved in. One that can't be read (see
 * `parsePalletLayout`) is left out rather than offered.
 */
export var selectSavedPalletLayouts = createSelector(selectLibraryItems, function (items) {
    return items
        .filter(function (item) { return item.kind === palletLayoutKind; })
        .sort(function (a, b) {
        return a.name.localeCompare(b.name, undefined, {
            numeric: true,
            sensitivity: "base",
        }) || a.lastEdited.localeCompare(b.lastEdited);
    })
        .flatMap(function (_a) {
        var id = _a.id, name = _a.name, lastEdited = _a.lastEdited, data = _a.data;
        var layout = parsePalletLayout(data);
        return layout ? [{ id: id, name: name, lastEdited: lastEdited, layout: layout }] : [];
    });
});
